import {AttributeLink} from '@acng/frontend-stargazer';

import {user} from '../../user/user.js';
import {onClick} from '../../layout/service/worker.js';
import {getLocalAmateur} from '../../amateurPool/context/amateur.js';
import {setGlobalDialog} from '../context/global-dialog.js';

/**
 * @group DOM Attribute
 */
const name = 'onclick-dialog';

AttributeLink(
  name,
  () => (element) =>
    onClick(element, (element) => {
      const {id, name: nickname} = getLocalAmateur(element);

      if (user.guestSignup('messenger.signupRequired', {nickname})) {
        return;
      }

      setGlobalDialog(id);
    }),
);

export {name as ONCLICK_DIALOG};
